import {z} from 'zod';

import {FinancialProductPreferenceCoordinatesSchema} from './FinancialProductPreferenceCoordinatesSchema';

export const UpdateFinancialProductPreferenceRequestBodySchema =
  FinancialProductPreferenceCoordinatesSchema.extend({
    /** Checked on save and ignored on non-persisting previews. */
    expectedPreferenceRevision: z.number(),
  });
export type UpdateFinancialProductPreferenceRequestBody = z.infer<
  typeof UpdateFinancialProductPreferenceRequestBodySchema
>;
